import React, { useEffect, useState } from "react";
import { Topbar } from "@components";
import {
  RootContainer,
  RefreshIcon,
  TopContainer,
  TopTitle,
  TopWrapper,
  BalanceText,
  LightTextLabel,
  LightText,
  LabelWrapper,
  ActionsWrapper,
  ActionButton,
  ActionLabel,
  ListTitle,
  ListContainer,
  EmptyText,
  ListRootContainer,
  LabelsContainer,
  ListTitleWrapper,
  SeeAllText,
} from "./Wallet.style";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE, PRIVATE_ROUTE } from "@router/route.constants";
import {
  TOPUP_LK,
} from "@constants";
import { useDispatch, useSelector } from "react-redux";
import { getFormattedNumber, localStorage } from "@utils";
import { api } from "@api";
import { saveUser } from "@redux/auth/authSlice";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import {
  TopUpOutlined,
  WithdrawOutlined,
  BalanceLoading,
  WinnerBg,
} from '@assets';
import { ContainerOutlined } from '@ant-design/icons';
import Lottie from "react-lottie";
import TransactionListItem from "./TransactionListItem/TransactionListItem";

const Wallet = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { main_balance, bonus, is_in_game } = useSelector((state) => state.auth.user);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  useEffect(() => {
    getRecentHistory();

    // eslint-disable-next-line
  }, []);

  const getRecentHistory = () => {
    setLoading(true);
    api
      .getRecentHistory()
      .then(({ transactions, user }) => {
        setLoading(false);
        setData(transactions);

        // Save user to redux
        dispatch(saveUser(user));
        // Set user to localstorage
        localStorage.setUser(user);
      })
      .catch((error) => { });
  };

  const goToHome = () => {
    navigate(`/${PUBLIC_ROUTE.HOME}`);
  };

  const goToTransactions = () => {
    navigate(`/${PRIVATE_ROUTE.TRANSACTIONS}`);
  };

  const handleTopUpClicked = () => {
    navigate(`/${PRIVATE_ROUTE.ACCOUNT_TYPE}/${TOPUP_LK}`);
  };

  const handleWithdrawClicked = () => {
    navigate(`/${PRIVATE_ROUTE.WITHDRAW_ACCOUNTS}`);
  };

  const refresh = () => {
    window.location.reload();
  };

  const renderTop = () => (
    <TopContainer>
      <TopWrapper>
        <TopTitle>{t("wallet.walletTotalBalance")}</TopTitle>
        <BalanceText>
          {is_in_game
            ? <Lottie
              options={{
                animationData: BalanceLoading,
              }}
              height={36}
            />
            : `${getFormattedNumber(main_balance + bonus)} Ks`
          }
        </BalanceText>
        <WinnerBg />
      </TopWrapper>
      <LabelsContainer>
        <LabelWrapper>
          <LightTextLabel>{t("wallet.actualTopupLabel")}</LightTextLabel>
          <LightText>{`${is_in_game ? '-' : getFormattedNumber(main_balance)} Ks`}</LightText>
        </LabelWrapper>
        <LabelWrapper>
          <LightTextLabel>{t("wallet.bonusLabel")}</LightTextLabel>
          <LightText>{`${is_in_game ? '-' : getFormattedNumber(bonus)} Ks`}</LightText>
        </LabelWrapper>
      </LabelsContainer>

      <ActionsWrapper>
        <ActionButton onClick={handleTopUpClicked}>
          <ActionLabel>
            {t("wallet.walletTopUp")}
          </ActionLabel>
          <TopUpOutlined />
        </ActionButton>

        <ActionButton onClick={handleWithdrawClicked}>
          <ActionLabel>
            {t("wallet.walletWithdraw")}
          </ActionLabel>
          <WithdrawOutlined />
        </ActionButton>
      </ActionsWrapper>

    </TopContainer>
  );

  const Loader = () => (
    <div className="loader">
      <Spin />
    </div>
  );

  const EmptyCard = () => (
    <div className="empty-box">
      <ContainerOutlined />
      <EmptyText>
        {t("common.noRecord")}
      </EmptyText>
    </div>
  );

  const List = () => (
    <ListRootContainer>
      <ListTitleWrapper>
        <ListTitle>
          {t("wallet.walletRecentHistory")}
        </ListTitle>
        <SeeAllText onClick={goToTransactions}>
          {t("wallet.walletSeeAll")}
        </SeeAllText>
      </ListTitleWrapper>
      <ListContainer>
        {data.map((item, key) => (
          <TransactionListItem key={key} item={item} />
        ))}
        {loading && <Loader />}
        {!loading && data.length === 0 && <EmptyCard />}
      </ListContainer>
    </ListRootContainer>
  );

  return (
    <RootContainer>
      <Topbar
        title={t("wallet.walletTitle")}
        shadow={false}
        rightIcon={<RefreshIcon onClick={refresh} />}
        goBack={goToHome}
      />
      {renderTop()}
      <List />
    </RootContainer>
  );
};

export default Wallet;
